export const partnerSchema = {
  role: 'RSP',
  rights: 0,
  approved: true,
  suspended: false,
  canceled: false,
  uniqueCode: '',
  services: [],
  technic: {
    info: '',
    contact: '',
    phoneWork: '',
    phoneMobile: '',
    emailPrimary: '',
    emailAlternative: ''
  },
  general: {
    aboutBusiness: '',
    annualRevenue: 0,
    numberOfCustomers: 0,
    customerAreas: '',
    other: ''
  },
  company: {
    name: '',
    abn: '',
    address: '',
    website: '',
    primaryContact: '',
    phoneWork: '',
    phoneMobile: '',
    emailPrimary: '',
    emailAlternative: ''
  },
  userInfo: {
    password: '',
    login: '',
    phoneNumber: ''
  }
}
